import { defineMessages } from 'react-intl';

const messages = defineMessages({
    allowDownloadLabel: {
        defaultMessage: 'Allow users with the shared link to download this item',
        description: 'Label for option to enable downloads on a shared link',
        id: 'boxui.share.sharedLinkSettings.allowDownloadLabel',
    },
    allowDownloadTitle: {
        defaultMessage: 'Allow Download',
        description: 'Title for Allow Download section',
        id: 'boxui.share.sharedLinkSettings.allowDownloadTitle',
    },
    directLinkLabel: {
        defaultMessage: 'Direct Link',
        description: 'Title for Direct Link section',
        id: 'boxui.share.sharedLinkSettings.directLinkLabel',
    },
    directDownloadBlockedByAccessPolicyWithClassification: {
        defaultMessage: 'Download has been disabled for content due to the classification.',
        description:
            'Text to show that direct link download is disabled due to applied shield access policy with classification',
        id: 'boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithClassification',
    },
    directDownloadBlockedByMaliciousContent: {
        defaultMessage: 'Download for this content has been disabled due to a security policy.',
        description: 'Text to show that direct link download is disabled due to security policy',
        id: 'boxui.share.sharedLinkSettings.directDownloadBlockedByMaliciousContent',
    },
    directDownloadBlockedByAccessPolicyWithoutClassification: {
        defaultMessage: 'Download has been disabled for content without classification.',
        description:
            'Text to show that direct link download is disabled due to applied shield access policy without classification',
        id: 'boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithoutClassification',
    },
    inaccessibleSettingsNotice: {
        defaultMessage: 'Certain settings may not be available for this item due to permissions.',
        description:
            'Notice shown at top of modal when one or more settings are unavailable due to permission settings',
        id: 'boxui.share.sharedLinkSettings.inaccessibleSettingsNotice',
    },
    modalTitle: {
        defaultMessage: 'Shared Link Settings',
        description: 'Title for shared link settings modal (title-case)',
        id: 'boxui.share.sharedLinkSettings.modalTitle',
    },
    customURLLabel: {
        defaultMessage: 'Non-private custom URL',
        description: 'Label for Custom URL text input field',
        id: 'boxui.share.sharedLinkSettings.customURLLabel',
    },
    expirationTitle: {
        defaultMessage: 'Link Expiration',
        description: 'Title for Link Expiration section',
        id: 'boxui.share.sharedLinkSettings.expirationTitle',
    },
    expirationLabel: {
        defaultMessage: 'Disable Shared Link on',
        description: 'Label for option to enable expiration on a shared link',
        id: 'boxui.share.sharedLinkSettings.expirationLabel',
    },
    passwordLabel: {
        defaultMessage: 'Require password',
        description: 'Label for checkbox to enable password on shared link',
        id: 'boxui.share.sharedLinkSettings.passwordLabel',
    },
    passwordPlaceholder: {
        defaultMessage: 'Enter a password',
        description: 'Placeholder for text input to enter a password',
        id: 'boxui.share.sharedLinkSettings.passwordPlaceholder',
    },
    passwordTitle: {
        defaultMessage: 'Password Protect',
        description: 'Title for section to add password to shared link',
        id: 'boxui.share.sharedLinkSettings.passwordTitle',
    },
    vanityNamePlaceholder: {
        defaultMessage: 'Enter a custom path (12 or more characters)',
        description: 'Placeholder for Custom URL text input field',
        id: 'boxui.share.sharedLinkSettings.vanityNamePlaceholder',
    },
    vanityNameNotSet: {
        defaultMessage: 'The custom URL has not been set',
        description: 'Text to show when a custom URL has not been set',
        id: 'boxui.share.sharedLinkSettings.vanityNameNotSet',
    },
    vanityURLWarning: {
        defaultMessage: 'Custom URLs should not be used when sharing sensitive content.',
        description: 'Text field for implications of using the custom (vanity) URL as a notice',
        id: 'boxui.share.sharedLinkSettings.vanityURLWarning',
    },
    vanityURLEnableText: {
        defaultMessage: 'Publish content broadly with a custom, non-private URL',
        description: 'Text label for custom URL section',
        id: 'boxui.share.vanityURLEnableText',
    },
    sharedLinkWarningText: {
        defaultMessage: 'This content is publicly available to anyone with the link.',
        description: 'Text displayed stating that content shared openly may be exposed to the public',
        id: 'boxui.share.sharedLinkSettings.sharedLinkWarningText',
    },
    withLinkViewDownload: {
        defaultMessage: 'This content is publicly available to anyone with the link, and can be viewed or downloaded.',
        description: 'Text to show when the access level of people with link and user can view and download',
        id: 'boxui.share.sharedLinkSettings.accessLevel.withLinkViewDownload',
    },
    withLinkView: {
        defaultMessage: 'This content is publicly available to anyone with the link, and can be viewed.',
        description: 'Text to show when the access level of people with link and user can view only',
        id: 'boxui.share.sharedLinkSettings.accessLevel.withLinkView',
    },
    inCompanyViewDownload: {
        defaultMessage:
            'This content is available to anyone within your company with the link, and can be viewed or downloaded.',
        description: 'Text to show when the access level of people in company and user can view and download',
        id: 'boxui.share.sharedLinkSettings.accessLevel.inCompanyViewDownload',
    },
    inCompanyView: {
        defaultMessage: 'This content is available to anyone within your company with the link, and can be viewed.',
        description: 'Text to show when the access level of people in company and user can view only',
        id: 'boxui.share.sharedLinkSettings.accessLevel.inCompanyView',
    },
    inItem: {
        defaultMessage: 'This content is available to invited collaborators with the link.',
        description: 'Text to show when the access level of people collaborate on the item',
        id: 'boxui.share.sharedLinkSettings.accessLevel.inItem',
    },
    sharedLinkSettingWarningLinkText: {
        defaultMessage: 'Learn more about shared link settings.',
        description: 'Text for the link used to navigate users to the relevant community article',
        id: 'boxui.share.sharedLinkSettings.sharedLinkSettingWarningLinkText',
    },
});

export default messages;
